import {useContext} from 'react';
import ThemeContextMobile from '../contextCreate/ThemeContextMobile';

const useTheme = () => {
	return useContext(ThemeContextMobile);
};

export default useTheme
